module.exports = __webpack_public_path__ + "static/media/device-info-es.3fff9a0f.png";